(function () {
  function addToCart(variantId, card) {
    if (!variantId) return;
    if (card) card.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function () {
        return fetch('/cart?section_id=cart-drawer');
      })
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newInner = doc.querySelector('.drawer__inner');
        var currentInner = document.querySelector('#CartDrawer .drawer__inner');

        if (newInner && currentInner) {
          currentInner.innerHTML = newInner.innerHTML;
        }

        var cartDrawerRoot = document.querySelector('cart-drawer');
        if (cartDrawerRoot) {
          cartDrawerRoot.classList.remove('is-empty');
          cartDrawerRoot.classList.add('animate', 'active');
          document.body.classList.add('overflow-hidden');
        }

        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          fetch('/cart?section_id=cart-icon-bubble')
            .then(function (res) {
              return res.text();
            })
            .then(function (bubbleHtml) {
              var bubbleDoc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
              var newBubble = bubbleDoc.getElementById('cart-icon-bubble');
              if (newBubble) bubble.innerHTML = newBubble.innerHTML;
            })
            .catch(function () {});
        }
      })
      .catch(function () {})
      .finally(function () {
        if (card) card.classList.remove('is-loading');
      });
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest('.related-products__select');
    if (!select || !select.value) return;
    var variantId = select.value;
    addToCart(variantId, select.closest('.related-products__card'));
    select.value = '';
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.related-products__add');
    if (!button || button.disabled) return;
    addToCart(button.getAttribute('data-variant-id'), button.closest('.related-products__card'));
  });
})();
